export default {
  authFail: 'get oauthCode failed',
  alipayParamsFail: 'alipay startupParams does not match',
  versionFail: 'version does not support getCode api',
  envFail: 'current env does not support getCode api'
}
